module.exports = __webpack_public_path__ + "img/cms-icon.5bc0aed3.png";